<!--
* 组件名 : 视频播放器
* 开发者 : JY
*
* 参数:
*   currentVideoData     { Object } -  当前视频信息
*
* 事件: 
*   close  [] - 关闭播放器
*
-->

<template>
  <section class="v-videos-player">
    <div class="player-body">
      <div class="player-wrap-box">
        <div class="player-wrap">
          <div id="player" :data-id="currentVideoData.vid" ref="player" />
        </div>
      </div>
    </div>
    <div class="video-info-content">
      <h4>{{ $P.uni2zg($TL.videoIntro) }}</h4>
      <div class="video-info" v-html="$P.uni2zg(currentVideoData.desc)" />
    </div>
    <v-btn
      class="close-btn linear-btn"
      :linear="true"
      color="#ffffff"
      @btnClick="on_close"
    >
      <v-icon>close</v-icon>
    </v-btn>
  </section>
</template>

<script>
import { i18n, timeout } from "utils/util";

export default {
  name: "v-videos-player",

  props: {
    currentVideoData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      vid: "",
      currentVideoObj: null,
    };
  },
  created() {
    this.vid = this.currentVideoData.vid;
    //  暂停全局音乐播放器
    this.$P.$emit("pause-all-audio", "stop");
  },
  mounted() {
    //  禁止主页面滚动
    document.body.classList.add("disabled-scroll");
    this.video_player_fn();
  },

  destroyed() {
    this.currentVideoObj = null;
  },

  methods: {
    /**
     * 右上角关闭按钮点击
     */
    on_close() {
      this.$emit("close");
    },

    /**
     * 生成视频播放器
     */
    video_player_fn() {
      if (this.vid) {
        this.currentVideoObj = $(this.$refs.player).G2embedded({
          videoId: this.vid,
          autoplay: true,
        });
      }
    },
  },
};
</script>

<style lang="scss">
.v-videos-player {
  position: fixed;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 1100;
  background-color: $color-white;
  overflow-y: auto;

  .player-body {
    width: 100%;
    background-color: #2a2b33;
  }

  .player-wrap-box {
    width: 1180px;
    margin: auto;

    @media (min-width: $lx-min) {
      width: 1364px;
    }
  }

  .player-wrap {
    width: 100%;
    padding-top: 56.25%;
    position: relative;
  }

  #player {
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;

    iframe {
      width: 100%;
      height: 100%;
    }
  }

  .video-info-content {
    width: 950px;
    margin: auto;

    margin: {
      top: 24px;
      left: auto;
      right: auto;
      bottom: 58px;
    }

    h4 {
      font-weight: 700;
      text-align: center;
      margin-bottom: 18px;
    }

    h4,
    .video-info,
    .video-info p {
      font-size: 18px;
      line-height: 1.67;
    }
  }

  .close-btn {
    position: absolute;
    right: 20px;
    top: 20px;

    .borderCircle {
      border-color: rgba(#fff, 0.8);
    }

    i {
      color: rgba(#fff, 0.8);
    }

    &:hover {
      i {
        color: $color-white !important;
      }
    }
  }
}
</style>
